import * as React from 'react';
import { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

const Root = styled(Button, { shouldForwardProp: (prop) => prop !== 'loading' })(
	({ theme, loading }) => ({
		padding: loading ? '6px 23px' : '6px 34px',
		borderRadius: 20,
		textTransform: 'none',
		'&:disabled': {
			backgroundColor: theme.palette.primary.light,
			color: theme.palette.text.contrast,
			opacity: 0.7
		}
	})
);

const ButtonLoader = styled(CircularProgress)(({ theme }) => ({
	width: '14px !important',
	height: '14px !important',
	color: theme.palette.text.contrast,
	marginLeft: 8
}));

export default function PrimaryButton({ disabled, ...props }) {
	const [loading, setLoading] = useState(false);

	/**
	 * Wraps the button function with loader states.
	 */
	const handleConfirm = async () => {
		setLoading(true);
		await props?.onClick();
		setLoading(false);
	};

	return (
		<Root
			variant="contained"
			disableElevation
			loading={loading}
			{...props}
			disabled={loading || disabled}
			onClick={handleConfirm}
		>
			{props.children}
			{loading && <ButtonLoader />}
		</Root>
	);
}
